// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__23q4n","imageUploader":"EGiftCard_imageUploader__3RES8"};